const SAMDESK_CDN_URL = "https://cdn.samdesk.io";

export const bubblesUrl = `${SAMDESK_CDN_URL}/sounds/bubbles.mp3`;
export const chimesUrl = `${SAMDESK_CDN_URL}/sounds/chimes.mp3`;
export const sonarUrl = `${SAMDESK_CDN_URL}/sounds/sonar.mp3`;
export const woodBlocksUrl = `${SAMDESK_CDN_URL}/sounds/wood_blocks.mp3`;
